import { useCallback } from 'react';
import type { To } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { hasPreviousLocation } from 'lib/routing';

export const useSafePreviousNavigate = (
  defaultPreviousLocation: To,
  delta?: number
) => {
  const navigate = useNavigate();

  return useCallback(() => {
    const backDelta = delta || -1;
    if (hasPreviousLocation(backDelta)) {
      navigate(backDelta);
    } else {
      navigate(defaultPreviousLocation, {
        replace: true,
      });
    }
  }, [navigate, delta, defaultPreviousLocation]);
};
